import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

interface CategoryNavProps {
  activeCategory?: string;
}

export default function CategoryNav({ activeCategory = 'all' }: CategoryNavProps) {
  return (
    <div className="flex items-center gap-2 overflow-x-auto pb-2 scrollbar-hide flex-wrap">
      {categories.map((cat) => (
        <Link
          key={cat.id}
          to={`/category/${cat.id}`}
          className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
            activeCategory === cat.id
              ? 'bg-primary-500 text-white'
              : 'bg-background-100 text-foreground-600 hover:bg-background-200'
          }`}
        >
          <div className="w-4 h-4 flex items-center justify-center">
            <i className={`${cat.icon} text-xs`}></i>
          </div>
          {cat.name}
          <span className={`text-xs ${activeCategory === cat.id ? 'text-white/70' : 'text-foreground-400'}`}>
            {cat.count}
          </span>
        </Link>
      ))}
    </div>
  );
}